import {Middleware} from 'redux'

import {persistSessionId} from './sessionPersistence'
import {setSessionId, startNewChat} from './slice'

export const chatSessionPersistenceMiddleware: Middleware =
  () => next => action => {
    const result = next(action)

    if (setSessionId.match(action)) {
      persistSessionId(action.payload)
    } else if (startNewChat.match(action)) {
      persistSessionId(null)
    }

    return result
  }
